<template>
    <a href="#" :class="triggerClass" @click.prevent="open = true">{{ triggerLabel }}</a>
    <Teleport to="body">
        <div class="st-modal" :class="{ 'st-modal--active': open }">
            <div class="st-modal__content">
                <div class="st-modal__header">
                    <div class="hero__header">{{ isEdit ? 'Rediger familiemedlem' : 'Registrer familiemedlem' }}</div>
                </div>
                <div class="st-modal__text">
                    <div v-if="error" class="form__error">{{ error }}</div>

                    <div class="family-member-field">
                        <label for="family-member-navn">Fornavn</label>
                        <input id="family-member-navn" type="text" v-model="Navn" required>
                    </div>
                    <div v-if="fieldErrors.Navn" class="form__field-error">{{ fieldErrors.Navn }}</div>

                    <div class="family-member-field">
                        <label for="family-member-etternavn">Etternavn</label>
                        <input id="family-member-etternavn" type="text" v-model="Etternavn" required>
                    </div>
                    <div v-if="fieldErrors.Etternavn" class="form__field-error">{{ fieldErrors.Etternavn }}</div>

                    <div class="family-member-field">
                        <label for="family-member-year">Fødselsår</label>
                        <input id="family-member-year" type="text" v-model="year" required>
                    </div>
                    <div v-if="fieldErrors.year" class="form__field-error">{{ fieldErrors.year }}</div>

                    <div class="form__option form__option--genders">
                        <label class="form__radio"><input type="radio" value="Mann" v-model="gender" required><span>Mann</span></label>
                        <label class="form__radio"><input type="radio" value="Kvinne" v-model="gender" required><span>Kvinne</span></label>
                        <label class="form__radio"><input type="radio" value="Annet" v-model="gender" required><span>Annet</span></label>
                        <label class="form__radio"><input type="radio" value="Ukjent" v-model="gender" required><span>Vil ikke svare</span></label>
                    </div>
                    <div v-if="fieldErrors.gender" class="form__field-error">{{ fieldErrors.gender }}</div>

                    <div class="form__option">
                        <label class="form__checkbox">
                            <input type="checkbox" v-model="anonym">
                            <span>Ikke publiser navn i topplistene for Ut i Nord</span>
                        </label>
                    </div>

                    <div class="mypage__editbar">
                        <button type="button" class="action" :disabled="submitting" @click="submit">{{ submitting ? 'Lagrer...' : 'Lagre' }}</button>
                        <button type="button" class="action action--hollow" :disabled="submitting" @click="close">Avbryt</button>
                    </div>

                    <div v-if="isEdit" class="family-member-accordion">
                        <button
                            type="button"
                            class="family-member-accordion__toggle"
                            :class="{ 'family-member-accordion__toggle--active': shareOpen }"
                            :aria-expanded="shareOpen"
                            @click="toggleShare"
                        >
                            <span>Deling av familiemedlemmet</span>
                            <i class="pi pi-chevron-down family-member-accordion__icon" aria-hidden="true"></i>
                        </button>
                        <div v-show="shareOpen" class="family-member-accordion__panel">
                            <h3>Brukere som deler familiemedlemmet</h3>
                            <div v-if="shareError" class="form__error">{{ shareError }}</div>
                            <ul v-if="shares.length" class="mypage-profile__action-list">
                                <li v-for="shareUser in shares" :key="shareUser.id" class="mypage-profile__action-row">
                                    <span>{{ shareUser.Navn }} {{ shareUser.Etternavn }} ({{ shareUser.e_mail }})</span>
                                </li>
                            </ul>
                            <h3>Del familiemedlemmet med en annen bruker</h3>
                            <p class="family-member-accordion__hint">Når familiemedlemmet er delt med en annen bruker kan du ikke trekke tilbake delingen siden dere blir likeverdige eiere av familiemedlemmet.</p>
                            <div class="family-member-share-row">
                                <div class="family-member-field">
                                    <label for="family-member-share-email">E-post</label>
                                    <input id="family-member-share-email" type="text" v-model="shareEmail" placeholder="E-post for brukeren">
                                </div>
                                <button type="button" class="action" :disabled="sharing" @click="submitShare">{{ sharing ? 'Deler...' : 'Del' }}</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isEdit" class="family-member-accordion">
                        <button
                            type="button"
                            class="family-member-accordion__toggle"
                            :class="{ 'family-member-accordion__toggle--active': convertOpen }"
                            :aria-expanded="convertOpen"
                            @click="toggleConvert"
                        >
                            <span>Gjør om til selvstendig bruker</span>
                            <i class="pi pi-chevron-down family-member-accordion__icon" aria-hidden="true"></i>
                        </button>
                        <div v-show="convertOpen" class="family-member-accordion__panel">
                            <p class="family-member-accordion__hint">Legg inn e-post adresse og passord for å gjøre om familiemedlemmet til en bruker med egen pålogging. Dette kan ikke reverseres.</p>
                            <div v-if="convertError" class="form__error">{{ convertError }}</div>
                            <div class="family-member-field">
                                <label for="family-member-convert-email">E-post adresse</label>
                                <input id="family-member-convert-email" type="text" v-model="convertEmail">
                            </div>
                            <div v-if="convertFieldErrors.email" class="form__field-error">{{ convertFieldErrors.email }}</div>
                            <div class="family-member-field">
                                <label for="family-member-convert-email-confirm">Bekreft e-post adresse</label>
                                <input id="family-member-convert-email-confirm" type="text" v-model="convertEmailConfirmation">
                            </div>
                            <div class="family-member-field">
                                <label for="family-member-convert-password">Passord</label>
                                <input id="family-member-convert-password" type="password" v-model="convertPassword" autocomplete="new-password">
                            </div>
                            <div v-if="convertFieldErrors.password" class="form__field-error">{{ convertFieldErrors.password }}</div>
                            <div class="family-member-field">
                                <label for="family-member-convert-password-confirm">Bekreft passord</label>
                                <input id="family-member-convert-password-confirm" type="password" v-model="convertPasswordConfirmation" autocomplete="new-password">
                            </div>
                            <div class="mypage__editbar">
                                <button type="button" class="action" :disabled="converting" @click="confirmConvert">{{ converting ? 'Gjør om...' : 'Gjør om til bruker' }}</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isEdit" class="family-member-accordion">
                        <button
                            type="button"
                            class="family-member-accordion__toggle"
                            :class="{ 'family-member-accordion__toggle--active': deleteOpen }"
                            :aria-expanded="deleteOpen"
                            @click="toggleDelete"
                        >
                            <span>Slett familiemedlem</span>
                            <i class="pi pi-chevron-down family-member-accordion__icon" aria-hidden="true"></i>
                        </button>
                        <div v-show="deleteOpen" class="family-member-accordion__panel">
                            <p class="family-member-accordion__hint">Når familiemedlemmet slettes vil turregistreringene bli anonymisert slik at turer fortsatt inngår i statistikken til turmålene uten at de kan knyttes til familiemedlemmet som person.</p>
                            <div v-if="deleteError" class="form__error">{{ deleteError }}</div>
                            <div class="mypage__editbar">
                                <button type="button" class="action action--hollow" :disabled="deleting" @click="confirmDelete">{{ deleting ? 'Sletter...' : 'Slett familiemedlem' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>

    <Teleport to="body">
        <div class="st-modal" :class="{ 'st-modal--active': confirmOpen }">
            <div class="st-modal__content">
                <div class="st-modal__header">
                    <div class="hero__header">Bekreft</div>
                </div>
                <div class="st-modal__text">
                    <p class="family-member-confirm-message">{{ confirmMessage }}</p>
                    <div class="mypage__editbar">
                        <button type="button" class="action" :disabled="converting || deleting" @click="acceptConfirm">{{ converting || deleting ? 'Vent...' : 'Bekreft' }}</button>
                        <button type="button" class="action action--hollow" :disabled="converting || deleting" @click="confirmOpen = false">Avbryt</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    csrfToken: { type: String, required: true },
    mode: { type: String, default: 'create' }, // 'create' | 'edit'
    member: { type: Object, default: null },
    triggerLabel: { type: String, default: '+ Legg til familiemedlem' },
    triggerClass: { type: String, default: '' },
});

const emit = defineEmits(['saved', 'converted', 'deleted']);

const isEdit = computed(() => props.mode === 'edit');

const open = ref(false);
const submitting = ref(false);
const error = ref(null);
const fieldErrors = ref({});

const Navn = ref(props.member?.Navn ?? '');
const Etternavn = ref(props.member?.Etternavn ?? '');
const year = ref(props.member?.year ?? '');
const gender = ref(props.member?.gender ?? 'Ukjent');
const anonym = ref(!!props.member?.anonym);

const shareOpen = ref(false);
const sharesLoaded = ref(false);
const shares = ref([]);
const shareEmail = ref('');
const sharing = ref(false);
const shareError = ref(null);

const convertOpen = ref(false);
const convertEmail = ref('');
const convertEmailConfirmation = ref('');
const convertPassword = ref('');
const convertPasswordConfirmation = ref('');
const converting = ref(false);
const convertError = ref(null);
const convertFieldErrors = ref({});

const deleteOpen = ref(false);
const deleting = ref(false);
const deleteError = ref(null);

const confirmOpen = ref(false);
const confirmMessage = ref('');
const confirmAction = ref(null);

function close() {
    open.value = false;
    error.value = null;
    fieldErrors.value = {};
    shareOpen.value = false;
    shareError.value = null;
    convertOpen.value = false;
    convertError.value = null;
    convertFieldErrors.value = {};
    deleteOpen.value = false;
    deleteError.value = null;
    confirmOpen.value = false;
    confirmAction.value = null;
}

function openConfirm(message, action) {
    confirmMessage.value = message;
    confirmAction.value = action;
    confirmOpen.value = true;
}

async function acceptConfirm() {
    confirmOpen.value = false;
    const action = confirmAction.value;
    confirmAction.value = null;
    if (action) {
        await action();
    }
}

async function toggleShare() {
    shareOpen.value = !shareOpen.value;
    if (shareOpen.value && !sharesLoaded.value) {
        await loadShares();
    }
}

async function loadShares() {
    try {
        const response = await fetch(`/xhr/frontend/family/${props.member.id}/shares`, {
            headers: { 'Accept': 'application/json' },
        });
        if (response.ok) {
            const data = await response.json();
            shares.value = data.shares || [];
            sharesLoaded.value = true;
        }
    } catch (e) {
        // Leave the list empty - the share form below still works.
    }
}

async function submitShare() {
    shareError.value = null;

    const email = shareEmail.value.trim();
    if (!email) {
        shareError.value = 'Fyll inn en e-postadresse';
        return;
    }

    sharing.value = true;
    try {
        const response = await fetch(`/xhr/frontend/family/${props.member.id}/shares`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': props.csrfToken,
            },
            body: JSON.stringify({ email }),
        });
        const data = await response.json();

        if (!response.ok) {
            shareError.value = data.message || 'Noe gikk galt, prøv igjen.';
            return;
        }

        shares.value = data.shares || [];
        sharesLoaded.value = true;
        shareEmail.value = '';
    } catch (e) {
        shareError.value = 'Noe gikk galt, prøv igjen.';
    } finally {
        sharing.value = false;
    }
}

function toggleConvert() {
    convertOpen.value = !convertOpen.value;
}

function confirmConvert() {
    openConfirm('Er du sikker på at du vil gjøre familiemedlemmet om til en selvstendig bruker?', submitConvert);
}

async function submitConvert() {
    convertError.value = null;
    convertFieldErrors.value = {};
    converting.value = true;

    try {
        const response = await fetch(`/xhr/frontend/family/${props.member.id}/convert`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': props.csrfToken,
            },
            body: JSON.stringify({
                email: convertEmail.value.trim(),
                email_confirmation: convertEmailConfirmation.value.trim(),
                password: convertPassword.value,
                password_confirmation: convertPasswordConfirmation.value,
            }),
        });
        const data = await response.json();

        if (!response.ok) {
            convertFieldErrors.value = data.errors || {};
            convertError.value = data.message || null;
            return;
        }

        // The member is no longer part of the current user's family list
        // once converted - let FamilyMemberList.vue remove this row.
        emit('converted', props.member.id);
        open.value = false;
    } catch (e) {
        convertError.value = 'Noe gikk galt, prøv igjen.';
    } finally {
        converting.value = false;
    }
}

function toggleDelete() {
    deleteOpen.value = !deleteOpen.value;
}

function confirmDelete() {
    openConfirm('Er du sikker på at du vil slette dette familiemedlemmet?', submitDelete);
}

async function submitDelete() {
    deleteError.value = null;
    deleting.value = true;

    try {
        const response = await fetch(`/xhr/frontend/family/${props.member.id}/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': props.csrfToken,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            deleteError.value = data.message || 'Noe gikk galt, prøv igjen.';
            return;
        }

        // The member is anonymized and no longer part of the current user's
        // family list - let FamilyMemberList.vue remove this row.
        emit('deleted', props.member.id);
        open.value = false;
    } catch (e) {
        deleteError.value = 'Noe gikk galt, prøv igjen.';
    } finally {
        deleting.value = false;
    }
}

async function submit() {
    error.value = null;
    fieldErrors.value = {};
    submitting.value = true;

    const url = isEdit.value
        ? `/xhr/frontend/family/${props.member.id}`
        : '/xhr/frontend/family';

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': props.csrfToken,
            },
            body: JSON.stringify({
                Navn: Navn.value,
                Etternavn: Etternavn.value,
                year: year.value,
                gender: gender.value,
                anonym: anonym.value,
            }),
        });
        const data = await response.json();

        if (!response.ok) {
            fieldErrors.value = data.errors || {};
            error.value = data.message || null;
            return;
        }

        emit('saved', data.member);
        open.value = false;
        if (!isEdit.value) {
            Navn.value = '';
            Etternavn.value = '';
            year.value = '';
            gender.value = '';
            anonym.value = false;
        }
    } catch (e) {
        error.value = 'Noe gikk galt, prøv igjen.';
    } finally {
        submitting.value = false;
    }
}
</script>

<style scoped>
/* Teleported outside the .form/.content-width wrapper that normally styles
   text inputs (see _form.scss) - restyled here to match, same approach as
   ChangePasswordModal.vue. */
.family-member-field {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 1rem;
}
.family-member-field label {
    font-size: 0.8rem;
    margin-bottom: 0.25rem;
}
.family-member-field input {
    border-radius: 4px;
    border: 1px solid #D3D9DE;
    background-color: #F2F5F8;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    color: #303939;
}
.family-member-field input:focus {
    outline: none;
    border-color: rgba(46, 90, 58, 0.3);
}
.family-member-share-row {
    display: flex;
    align-items: flex-end;
    gap: 0.75rem;
    flex-wrap: wrap;
}
.family-member-share-row .family-member-field {
    flex: 1;
    min-width: 12rem;
    margin-bottom: 0;
}
.family-member-accordion {
    margin-top: 1.5rem;
    border: 1px solid #D3D9DE;
    border-radius: 8px;
    overflow: hidden;
    text-align: left;
}
.family-member-accordion__toggle {
    appearance: none;
    -webkit-appearance: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    background-color: #F2F5F8;
    border: 0;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    font-weight: bold;
    color: #303939;
    cursor: pointer;
    text-align: left;
}
.family-member-accordion__icon {
    flex-shrink: 0;
    transition: transform 0.2s ease;
}
.family-member-accordion__toggle--active .family-member-accordion__icon {
    transform: rotate(180deg);
}
.family-member-accordion__panel {
    padding: 1rem;
    border-top: 1px solid #D3D9DE;
}
.family-member-accordion__panel h3:first-child {
    margin-top: 0;
}
.family-member-accordion__hint {
    font-size: 0.85rem;
    color: #6b7373;
    margin: 0 0 0.75rem;
}
.family-member-confirm-message {
    text-align: center;
}
</style>
